export const colors = {
  veryLightGrayishBlue: 'hsl(240, 78%, 98%)',
  lightGrayishBlue: 'hsl(234, 14%, 74%)',
  grayishBlue: 'hsl(233, 13%, 49%)',
  darkGrayishBlue: 'hsl(232, 13%, 33%)',
  purpleText: 'hsl(237,63%,65%)'

}

export const gradient = 'linear-gradient(135deg, #A2A7F0 0.06%, #696EDD 100.06%)'